// GalleryViewCompact.jsx

import React from 'react';

// Components
import GalleryView from './GalleryView';

const MAX_NODES = 20;

/**
 * GalleryViewCompact
 *
 * Compact gallery renderer for constrained surfaces (e.g. dashboard cards).
 * Reuses GalleryView with a node cap to avoid duplicating layout logic.
 *
 * @returns {ReactNode} The rendered component.
 */
const GalleryViewCompact = React.memo(({
  enforceExplicitProperties = false,
  view,
  typeDef,
  nodes = [],
  language = 'en',
  onItemClick = null,
}) => {

  // ----- RENDER ----- //

  return (
  <GalleryView
    enforceExplicitProperties={enforceExplicitProperties}
    view={view}
    typeDef={typeDef}
    nodes={nodes}
    language={language}
    maxNodes={MAX_NODES}
    onItemClick={onItemClick}
  />
);
});

// Dev Tools
GalleryViewCompact.displayName = 'GalleryViewCompact';

export default GalleryViewCompact;
